import React, { memo, useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";

import { formatNumber, formatNumberPS, formatNumber_N1, formatPrice, formatPrice_N1, priceToNumber } from "../../helpers/utils";

import { getFromApiAsync } from "../../helpers/apiHelper";
import { useSelector } from "react-redux";
import { HighlightSpan } from "../PriceBoardTotalMode";

export default memo(
  function StockMatchDetailV2(props) {
    const { t } = useTranslation();

    const { symbolInfo, isDerivative } = props;
    const counter = useSelector((state) => state.gSymbol.symbolInfos.find((e) => e.code === symbolInfo.code).counter);
    const prevSymbolCode = useRef(""); // .current
    const prevArrData = useRef([]);
    const [arrData, setArrData] = useState([]);

    useEffect(() => {
      if (symbolInfo && Object.keys(symbolInfo).length > 0) {
        let arr = [];
        arr.push(
          { klmua: symbolInfo.bidQtty1, giamua: symbolInfo.bidPrice1, giaban: symbolInfo.offerPrice1, klban: symbolInfo.offerQtty1 },
          { klmua: symbolInfo.bidQtty2, giamua: symbolInfo.bidPrice2, giaban: symbolInfo.offerPrice2, klban: symbolInfo.offerQtty2 },
          { klmua: symbolInfo.bidQtty3, giamua: symbolInfo.bidPrice3, giaban: symbolInfo.offerPrice3, klban: symbolInfo.offerQtty3 },
          { klmua: symbolInfo.bidQtty4, giamua: symbolInfo.bidPrice4, giaban: symbolInfo.offerPrice4, klban: symbolInfo.offerQtty4 },
          { klmua: symbolInfo.bidQtty5, giamua: symbolInfo.bidPrice5, giaban: symbolInfo.offerPrice5, klban: symbolInfo.offerQtty5 },
          { klmua: symbolInfo.bidQtty6, giamua: symbolInfo.bidPrice6, giaban: symbolInfo.offerPrice6, klban: symbolInfo.offerQtty6 },
          { klmua: symbolInfo.bidQtty7, giamua: symbolInfo.bidPrice7, giaban: symbolInfo.offerPrice7, klban: symbolInfo.offerQtty7 },
          { klmua: symbolInfo.bidQtty8, giamua: symbolInfo.bidPrice8, giaban: symbolInfo.offerPrice8, klban: symbolInfo.offerQtty8 },
          { klmua: symbolInfo.bidQtty9, giamua: symbolInfo.bidPrice9, giaban: symbolInfo.offerPrice9, klban: symbolInfo.offerQtty9 },
          { klmua: symbolInfo.bidQtty10, giamua: symbolInfo.bidPrice10, giaban: symbolInfo.offerPrice10, klban: symbolInfo.offerQtty10 }
        );
        prevArrData.current = arrData;
        setArrData(arr);
      }
    }, [counter]);

    const getClass = (key, field) => {
      if (!prevArrData.current[key]) return "";
      return arrData[key][field] !== prevArrData.current[key][field] ? "changed" : "";
    };

    return (
      <div className={props.className} style={props.style}>
        <div className="d-flex flex-column h-100 side-tab-table">
          <div className="prc-row-head v1">
            <div className={"prc-col2 justify-content-start"}>{t("klMua")}</div>
            <div className={"prc-col2 justify-content-center"}>{t("giaMua")}</div>
            <div className={"prc-col2 justify-content-center"}>{t("giaBan")}</div>
            <div className={"prc-col2 justify-content-end"}>{t("klBan")}</div>
          </div>
          <div className="flex-1" style={{ position: "relative" }}>
            {arrData.map((item, index) => {
              const getDynamicProperty = (obj, index, property) => obj[`${property}${index + 1}_color`];

              const bidQtty = getDynamicProperty(symbolInfo, index, "bidQtty");
              const bidPrice = getDynamicProperty(symbolInfo, index, "bidPrice");
              const offerPrice = getDynamicProperty(symbolInfo, index, "offerPrice");
              const offerQtty = getDynamicProperty(symbolInfo, index, "offerQtty");

              return (
                <div className={clsx("prc-row ps")} key={index}>
                  <div className={clsx(`prc-col2 text-left justify-content-start ${bidQtty}`, getClass(index, "klmua"))}>{item.klmua}</div>
                  <div className={clsx(`prc-col2 text-center ${bidPrice}`, getClass(index, "giamua"))}>{isDerivative ? formatNumberPS(item.giamua) : item.giamua}</div>
                  <div className={clsx(`prc-col2 text-center ${offerPrice}`, getClass(index, "giaban"))}>{isDerivative ? formatNumberPS(item.giaban) : item.giaban}</div>
                  <div className={clsx(`prc-col2 text-right ${offerQtty}`, getClass(index, "klban"))}>{item.klban}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.code === nextProps.code) {
      return true; // props are equal
    }
    return false; // props are not equal -> update the component
  }
);
